import './index.scss'

$(document).ready(function(){
  if(window.location.hash != '' && window.location.hash.indexOf('md') != -1){
    console.log(11)
    let h
    if($(window).width()>1024){
      h = $('.ny-nav').offset().top - 50
    }else if($(window).width()<=1024 && $(window).width()>767){
      h = $('.ny-nav').offset().top - 100
    }else{
      h = $('.section2').offset().top - 60
    }
    $("html, body").animate({
      scrollTop: h
    },0);
  }
})
